import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Layers, Lock, Zap } from 'lucide-react';
const reasons = [{
  title: 'Cross-Border Expertise',
  description: 'Benefit from our dual presence in the US and Jordan, offering seamless communication, cultural alignment, and cost-effective top-tier talent.',
  icon: Globe
}, {
  title: 'End-to-End Delivery',
  description: 'From initial strategy and UX design to development, deployment, and ongoing maintenance, we handle the entire product lifecycle.',
  icon: Layers
}, {
  title: 'Quality-First Engineering',
  description: 'Quality is built into our DNA. We follow rigorous testing, code review, and best practices to ensure your products are reliable and performant.',
  icon: Lock
}, {
  title: 'Agile Methodology',
  description: 'We adapt to your needs quickly. Our iterative approach ensures transparency, rapid prototyping, and faster time-to-market.',
  icon: Zap
}];
export function WhyChooseUs() {
  return <section id="why-us" className="py-24 bg-primary text-white" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-196">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-197">
            Why Choose AlUniversalApps
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-300" data-id="element-198">
            We don't just build software; we build strategic partnerships that
            drive tangible business outcomes.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-199">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-primary-light rounded-2xl p-8 border border-white/5 hover:border-accent/50 transition-colors group" data-id="element-200">
              <div className="flex items-start gap-6" data-id="element-201">
                <div className="w-14 h-14 rounded-xl bg-white/5 flex items-center justify-center shrink-0 group-hover:bg-accent/20 transition-colors" data-id="element-202">
                  <reason.icon className="w-7 h-7 text-accent" data-id="element-203" />
                </div>
                <div data-id="element-204">
                  <h3 className="text-xl font-bold mb-3" data-id="element-205">{reason.title}</h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-206">
                    {reason.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}